import { db, auth } from '../services/firebase.js';

export const Auth = {
  data() {
    return {
      mode: "login", // or 'register'
      loginEmail: "",
      loginPassword: "",
      registerEmail: "",
      registerPassword: "",
      registerConfirmPassword: "",
      authError: "",
      isLoading: false
    };
  },
  methods: {
    async handleLogin() {
      if (!this.loginEmail || !this.loginPassword) {
        this.authError = "Please fill in all fields";
        return;
      }
      this.isLoading = true;
      try {
        await auth.signInWithEmailAndPassword(
          this.loginEmail,
          this.loginPassword
        );
        this.$router.push("/");
      } catch (error) {
        this.authError = error.message;
      }
      this.isLoading = false;
    },

    async handleRegister() {
      if (
        !this.registerEmail ||
        !this.registerPassword ||
        !this.registerConfirmPassword
      ) {
        this.authError = "Please fill in all fields";
        return;
      }
      if (this.registerPassword !== this.registerConfirmPassword) {
        this.authError = "Passwords do not match";
        return;
      }
      this.isLoading = true;
      try {
        const { user } = await auth.createUserWithEmailAndPassword(
          this.registerEmail,
          this.registerPassword
        );
        await db.ref(`users/${user.uid}`).set({
          email: user.email,
          createdAt: firebase.database.ServerValue.TIMESTAMP
        });
        this.$router.push("/");
      } catch (error) {
        this.authError = error.message;
      }
      this.isLoading = false;
    },

    async handleResetPassword() {
      if (!this.loginEmail) {
        this.authError = "Please enter your email";
        return;
      }
      try {
        await auth.sendPasswordResetEmail(this.loginEmail);
        this.authError = "Password reset email sent!";
      } catch (error) {
        this.authError = error.message;
      }
    },

    toggleMode() {
      this.mode = this.mode === "login" ? "register" : "login";
      this.authError = "";
    }
  },
  template: "#auth"
};
